"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ColorArea: function() {
        return _ColorArea.ColorArea;
    },
    colorAreaCSSVars: function() {
        return _useColorAreaStylesstyles.colorAreaCSSVars;
    },
    colorAreaClassNames: function() {
        return _useColorAreaStylesstyles.colorAreaClassNames;
    },
    renderColorArea_unstable: function() {
        return _renderColorArea.renderColorArea_unstable;
    },
    useColorAreaStyles_unstable: function() {
        return _useColorAreaStylesstyles.useColorAreaStyles_unstable;
    },
    useColorArea_unstable: function() {
        return _useColorArea.useColorArea_unstable;
    }
});
const _ColorArea = require("./ColorArea");
const _renderColorArea = require("./renderColorArea");
const _useColorArea = require("./useColorArea");
const _useColorAreaStylesstyles = require("./useColorAreaStyles.styles");
